import { infoPanelActionTypes } from '../actions/infoPanel-action-types';

const initialInfoPanelState = {
	
	currentAsset:{},
	rotation:0
};

export const infoPanel = (state = initialInfoPanelState, action) => {
	switch (action.type) {
		
			case infoPanelActionTypes.INFO_PANEL_SET_ASSET:
				return{...state, currentAsset: action.asset};
			case infoPanelActionTypes.INFO_PANEL_SET_ROTATION:
				return{...state, rotation: action.rotation};

			
		default:
			return state;
	}
};





// WEBPACK FOOTER //
// ./src/infoPanel/reducers/infoPanel-reducer.js